import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './WeekSwitcher.css';

// "2026-08-28" -> "28 Aug". Parsed by hand: new Date('2026-08-28') is UTC
// midnight, which renders as the 27th in a UTC-negative timezone.
function shortDate(iso) {
  const [, m, d] = String(iso).split('-').map(Number);
  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  return `${d} ${months[m - 1]}`;
}

export default function WeekSwitcher({ meetings, currentId }) {
  const list = [...(meetings || [])].sort((a, b) => a.meeting_date.localeCompare(b.meeting_date));
  const currentRef = useRef(null);

  // Meetings render oldest-first in a horizontally-scrolling strip; past ~8
  // meetings the current "Viewing" chip is off-screen on load. Bring it into
  // view once on mount. jsdom (used by tests) has no scrollIntoView, so guard it.
  useEffect(() => {
    if (currentRef.current && typeof currentRef.current.scrollIntoView === 'function') {
      currentRef.current.scrollIntoView({ block: 'nearest', inline: 'center' });
    }
  }, [currentId]);

  if (list.length < 2) return null;

  return (
    <nav className="ml-weeks" aria-label="Meeting weeks">
      {list.map(m => {
        const current = Number(m.id) === Number(currentId);
        const label = shortDate(m.meeting_date);
        const inner = (
          <>
            <span className="ml-week-d" data-testid="week-date">{label}</span>
            <span className="ml-week-s">{current ? 'Viewing' : 'Meeting'}</span>
          </>
        );
        return current
          ? <span className="ml-week on" data-testid="week-current" ref={currentRef} key={m.id}>{inner}</span>
          : <Link className="ml-week" data-testid="week" to={`/meetings/${m.id}`} key={m.id}>{inner}</Link>;
      })}
    </nav>
  );
}
